(function() {
  'use strict';

  angular
    .module('ykwx', [
    	// Generated modules
        'ngAnimate', 
    	'ngCookies', 
    	'ngTouch', 
    	'ngSanitize', 
    	'ngResource', 
    	'ngRoute', 
    	'ngMaterial',
        'ngCachedResource',
        'ui.router',
        // Dropdown lists
        'ngDropdowns',
        // Time and time ago
        'angularMoment',
        // Smooth scroll
        'duScroll',
        // Waypoints for scroll [not used to delete]
        'zumba.angular-waypoints',
        // Addthis for angular
        'sn.addthis',
        // Loading bar
        'angular-loading-bar',
        // Page titles & Meta data
        'viewhead',
        // Google Analytics
        // 'angulartics', 
        // 'angulartics.google.analytics'

    ]);

})();

angular.module('ykwx')

	.controller('StaticPagesHomeController', function($scope, $rootScope) {

		// Meta data
		$rootScope.pageTitle = "Home";
		$rootScope.pageDescription = "";
		$rootScope.pageUrl = "home";
		$rootScope.pageImage = "";

	})


	;
angular.module('ykwx')
  	
	.controller('AppController', function($scope, $rootScope, $document, $window, $timeout, $location, $stateParams, $state) {
		// Current year
		$scope.year = moment().year();

	    // Scroll to top on page load
		$scope.$on('$viewContentLoaded', function(){
			$document.scrollTopAnimated(0, 100);
		});


	});

(function() {
  'use strict';

  angular
    .module('ykwx')
    .constant('moment', moment)

    ;
    
})();

(function() {
  'use strict';

  angular
    .module('ykwx')
    
    // The CMS API 
    .factory('Api', function($cachedResource, Endpoint) {
        return function(key) {
            key = key.join? key.join('/'):key;
            return $cachedResource(key, Endpoint + key + '/:id.json', {id: "@id"}, {
                'update': {method: 'PUT'}
            });
        };
    })

    // Trusted hosts [ie, a url from youtube, vimeo hosted files etc]
    .filter('trustUrl', function ($sce) {
        return function (url) {
            return $sce.trustAsResourceUrl(url);
        };
    })

    // Trust embed 
    .filter('trustEmbed', function ($sce) {
        return function (value) {
            return $sce.trustAsHtml(value);
        };
    })

    // Capitalise text
    .filter('capitalize', function() {
        return function(input, all) {
            return (!!input) ? input.replace(/([^\W_]+[^\s-]*) */g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();}) : '';
        };
    })

    // Replace hyphens with amp
    .filter('tidy', function() {
        return function(str) {
            return str.replace("-", " & ");
        };
    })

    // Replace hyphens with space
    .filter('space', function() {
        return function(str) {
            return str.replace("-", " ");
        };
    })

    // Chop text string if longer than defined length
    .filter('strLimit', ['$filter', function($filter) {
        return function(input, limit) {
            if (! input) return;
            if (input.length <= limit) {
                return input;
            }
            return $filter('limitTo')(input, limit) + '...';
        };

    }])

    
    // Use on daily digest to clean up url source
    .filter('domain', [ function () {
        return function (input) {
            var elements = angular.element('<a href="'+input+'"/>');
			var d = elements[0].hostname;
			if(d.indexOf("www.") > -1) {
				var domain = d.replace("www.","");
			}
			else {
				var domain = d;
			}
            return domain;
        };
    }])

    // Strip quote marks from pull quotes
    .filter('removeQuoteMarks', [ function () {
      return function(str) {
          return str.replace('"', "").replace('"', "").replace('“', "");
      };
    }])

    // Strip quote marks from pull quotes
    .filter('removeTheS', [ function () {
      return function(str) {
          return str.replace("/s\b/", "");
      };
    }])


    
    // Strip URL from iframe
    .filter("stripUrl", function() {
        return function(str) {
            var re = /\ssrc=(?:(?:'([^']*)')|(?:"([^"]*)")|([^\s]*))/i,
                res = str.match(re),
                src = res[1]||res[2]||res[3];
            return src;
        };
     })



    ;

})();



(function() {
  'use strict';

  angular
    .module('ykwx')
    .config(routeConfig)
    

  function routeConfig($stateProvider, $locationProvider) {

    $locationProvider.html5Mode(true);
    // $locationProvider.hashPrefix('!');

    
    // Routes for the site
    $stateProvider

      .state('home', {
        url: '/',
        templateUrl: 'templates/views/static_pages/home.html',
        controller: 'StaticPagesHomeController'
      })
      

      ;
  }



})();

(function() {
  'use strict';

  angular
    .module('ykwx')

    .directive('mdHeader', function header() {
        var header = {
        	restrict: 'E',
          	templateUrl: 'templates/views/shared/header.html'
        };
        return header;
    })

    .directive('mdFooter', function footer() {
        var footer = {
          	restrict: 'E',
          	templateUrl: 'templates/views/shared/footer.html'
        };
        return footer;
    })


    // Smooth transition between pages
    .directive('smoothLoad', function ($window, $rootScope, $timeout) {
        return function() {

            $rootScope.$on('$stateChangeStart', function(){ 
                $('body').addClass('load');
            })

            $rootScope.$on('$stateChangeSuccess', function(){
                $('body').removeClass('load');
            })

        };
    })



})();






















angular.module("ykwx").run(["$templateCache", function($templateCache) {$templateCache.put("templates/views/shared/footer.html","<footer role=\"contentInfo\"><a href=\"http://patio.cool\"><span>Made by Patio</span><span class=\"material-icons\">local_pizza</span><span ng-bind-html=\"year\"></span></a></footer>");
$templateCache.put("templates/views/shared/header.html","<search></search><header role=\"banner\"><div class=\"head-container hide-on-mobile\"><h1><a class=\"p_logo icon_logo\" href=\"/\" md-no-ink=\"\">patio</a></h1></div></header>");
$templateCache.put("templates/views/static_pages/home.html","<md-content><div class=\"page\"><section id=\"one\"><svg enable-background=\"new 0 0 420.5 166.5\" height=\"166.5px\" id=\"patio-logo\" version=\"1.1\" viewbox=\"0 0 420.5 166.5\" width=\"420.5px\" x=\"0px\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" y=\"0px\"><g><path d=\"M20.865,46.048h22.734v10.059c2.205-6.613,11.161-11.436,23.01-11.436 c21.908,0,38.304,17.636,38.304,39.957c0,22.183-16.396,39.958-38.304,39.958c-11.85,0-20.806-4.686-23.01-11.437v39.682H20.865 V46.048z M62.476,103.918c11.023,0,19.565-8.405,19.565-19.29s-8.542-19.29-19.565-19.29c-11.161,0-20.254,8.405-20.254,19.29 S51.315,103.918,62.476,103.918z\" fill=\"#C5D5A9\"></path><path d=\"M151.76,44.671c11.85,0,20.806,4.685,23.01,11.436V46.048h22.734v77.159h-22.734v-10.058 c-2.205,6.613-11.161,11.437-23.01,11.437c-21.908,0-38.304-17.637-38.304-39.958C113.456,62.444,129.853,44.671,151.76,44.671z M155.894,103.918c11.161,0,20.254-8.405,20.254-19.29s-9.094-19.29-20.254-19.29c-11.023,0-19.565,8.405-19.565,19.29 S144.871,103.918,155.894,103.918z\" fill=\"#C5D5A9\"></path><path d=\"M217.897,66.716h-10.334V46.048h10.196V16.425h22.184V45.91h16.947v20.668h-16.947v56.492h-22.184V66.716 H217.897z\" fill=\"#C5D5A9\"></path><path d=\"M271.357,26.621c0-7.303,5.926-12.952,12.951-12.952c7.166,0,12.953,5.649,12.953,12.952 c0,7.164-5.787,12.813-12.953,12.813C277.42,39.435,271.357,33.785,271.357,26.621z M273.148,46.048h22.734v77.159h-22.734V46.048z\" fill=\"#C5D5A9\"></path><path d=\"M356.783,43.706c23.699,0,42.852,18.05,42.852,40.922s-19.152,40.922-42.852,40.922 c-23.836,0-42.85-18.05-42.85-40.922S332.947,43.706,356.783,43.706z M356.783,104.744c11.162,0,19.98-8.818,19.98-20.254 c0-11.16-8.818-20.254-19.98-20.254c-11.297,0-19.979,9.094-19.979,20.254C336.805,95.926,345.486,104.744,356.783,104.744z\" fill=\"#C5D5A9\"></path></g></svg><a du-smooth-scroll=\"\" duration=\"500\" ng-href=\"#two\"><svg enable-background=\"new 0 0 72.667 22.167\" height=\"22px\" id=\"arrow\" version=\"1.1\" viewbox=\"0 0 72.667 22.167\" width=\"72px\" x=\"0px\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" y=\"0px\"><g><line fill=\"none\" stroke=\"#C6D5A9\" x1=\"2.167\" x2=\"36.5\" y1=\"2.583\" y2=\"19.583\"></line><line fill=\"none\" stroke=\"#C6D5A9\" x1=\"70.5\" x2=\"36.167\" y1=\"2.583\" y2=\"19.583\"></line></g></svg></a></section><section id=\"two\"><div class=\"block wrapper-small center-text\"><p>We specialise in branding, design, web development, and strategy for food and drink entrepreneurs.</p><p>We are a group of creatives obsessed with great food and great ideas. We work with inspiring entrepreneurs to help them spread the word about what they do. And we do it all with honesty, transparency and flexibility.</p></div><a du-smooth-scroll=\"\" duration=\"500\" ng-href=\"#three\"><svg enable-background=\"new 0 0 72.667 22.167\" height=\"22px\" id=\"arrow\" version=\"1.1\" viewbox=\"0 0 72.667 22.167\" width=\"72px\" x=\"0px\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" y=\"0px\"><g><line fill=\"none\" stroke=\"#CA1B23\" x1=\"2.167\" x2=\"36.5\" y1=\"2.583\" y2=\"19.583\"></line><line fill=\"none\" stroke=\"#CA1B23\" x1=\"70.5\" x2=\"36.167\" y1=\"2.583\" y2=\"19.583\"></line></g></svg></a></section><section id=\"three\"><div class=\"wrapper-small center-text\"><h2 class=\"subheader\">Some of our recent projects</h2></div><div class=\"case-study lyles\"><img ng-src=\"../assets/images/lyles-home.jpg\"><div class=\"overlay\"><a class=\"text\" ng-href=\"http://www.lyleslondon.com\" target=\"_blank\"><h2>Lyle\'s</h2><p>Michelin starred restaurant in London</p><p>www.lyleslondon.com</p></a></div></div><div class=\"case-study homeslice\"><img ng-src=\"../assets/images/homeslice-home.jpg\"><div class=\"overlay\"><a class=\"text\" ng-href=\"http://www.homeslicepizza.co.uk/\" target=\"_blank\"><h2>Homeslice</h2><p>Pizza restaurants across London</p><p>www.homeslicepizza.co.uk</p></a></div></div><div class=\"case-study clapton\"><img ng-src=\"../assets/images/claptoncraft-home.jpg\"><div class=\"overlay\"><a class=\"text\" ng-href=\"http://www.claptoncraft.co.uk/\" target=\"_blank\"><h2>Clapton Craft</h2><p>Craft beer and growler refil stores across London</p><p>www.claptoncraft.co.uk</p></a></div></div><div class=\"case-study salutations\"><img ng-src=\"../assets/images/salutations-home.jpg\"><div class=\"overlay\"><a class=\"text\" ng-href=\"http://salutations.studio\" target=\"_blank\"><h2>Salutations</h2><p>Home and kitchenware store and blog</p><p>www.salutations.studio</p></a></div></div><a du-smooth-scroll=\"\" duration=\"500\" ng-href=\"#four\"><svg enable-background=\"new 0 0 72.667 22.167\" height=\"22px\" id=\"arrow\" version=\"1.1\" viewbox=\"0 0 72.667 22.167\" width=\"72px\" x=\"0px\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" y=\"0px\"><g><line fill=\"none\" stroke=\"#D26F5D\" x1=\"2.167\" x2=\"36.5\" y1=\"2.583\" y2=\"19.583\"></line><line fill=\"none\" stroke=\"#D26F5D\" x1=\"70.5\" x2=\"36.167\" y1=\"2.583\" y2=\"19.583\"></line></g></svg></a></section><section id=\"four\"><div class=\"block wrapper-small center-text\"><a class=\"btn\" ng-href=\"mailto:info@patio.cool\" target=\"_blank\"><span>Say hello</span><span class=\"material-icons\">pan_tool</span></a></div><md-footer></md-footer></section></div></md-content>");}]);